// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceProfilePopup__profile-fffee6 {
  padding-top: 24px;
  padding-bottom: 24px;
  --space-profile-padding: 24px;
}

.SpaceProfilePopup__profile-meta-block-fb8122 {
  --meta-block-padding: 24px;
  --meta-block-actions-background: var(--base-10);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SpaceProfilePopup/SpaceProfilePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,oBAAA;EAEA,6BAAA;AAAF;;AAGA;EACE,0BAAA;EACA,+CAAA;AAAF","sourcesContent":[".profile {\n  padding-top: 24px;\n  padding-bottom: 24px;\n\n  --space-profile-padding: 24px;\n}\n\n.profile-meta-block {\n  --meta-block-padding: 24px;\n  --meta-block-actions-background: var(--base-10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile": `SpaceProfilePopup__profile-fffee6`,
	"profile-meta-block": `SpaceProfilePopup__profile-meta-block-fb8122`,
	"profileMetaBlock": `SpaceProfilePopup__profile-meta-block-fb8122`
};
module.exports = ___CSS_LOADER_EXPORT___;
